import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';

export const creditScoreService = {
  getCreditScoreList,
  getCreditScoreDetails,
  searchCreditScore,
};

async function getCreditScoreList() {
  return apiClient.get(`/credit-score`, authHeader());
}

async function getCreditScoreDetails(id) {
  return apiClient.get(`/credit-score/details/${id}`, authHeader());
}

async function searchCreditScore(text) {
  return apiClient.get(`/credit-score/search?search=${encodeURIComponent(text)}`, authHeader());
}
